(function () {
  const BANNER_IMAGE = 'https://cdn.shopify.com/s/files/1/1066/2202/6060/files/bestsellers-banner-megamenu.jpg?v=1782390911';
  const BANNER_LINK = '/collections/bestsellers';
  const BANNER_TEXT = 'Bekijk onze bestsellers';
  
  function setupMegaMenu(list) {
    if (!list) return;
    
    // --- 1. Banner injecteren (indien nog niet aanwezig) ---
    if (!list.querySelector('.mega-menu__banner')) {
      const banner = document.createElement('a');
      banner.className = 'mega-menu__banner';
      banner.href = BANNER_LINK;
      banner.innerHTML = `
        <img src="${BANNER_IMAGE}" alt="" loading="lazy">
        <span class="mega-menu__banner__text">${BANNER_TEXT}</span>
      `;
      list.appendChild(banner);
    }
    
    // --- 2. Hover-staat vasthouden ---
    const columns = list.querySelectorAll('.mega-menu__column');
    if (!columns.length) return;
    
    // Eerste categorie standaard actief (zoals in het ontwerp)
    if (!list.querySelector('.mega-menu__column--active')) {
      columns[0].classList.add('mega-menu__column--active');
    }
    
    let hoverTimer = null;
    const activate = (col) => {
      columns.forEach((c) => c.classList.toggle('mega-menu__column--active', c === col));
    };
    
    columns.forEach((col) => {
      if (col.dataset.megaBound === 'true') return; // voorkom dubbele listeners
      col.dataset.megaBound = 'true';
      
      // Alleen de parent-link (linkerkolom) activeert, niet de hele li incl. sublijst
      const trigger = col.querySelector('.mega-menu__link--parent') || col;
      
      // Hover-intent: korte vertraging zodat schuin bewegen naar de sublijst
      // niet per ongeluk een andere categorie activeert (anti-flikker)
      trigger.addEventListener('pointerenter', () => {
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(() => activate(col), 120);
      });
      trigger.addEventListener('pointerleave', () => clearTimeout(hoverTimer));
      
      // Toetsenbord: direct activeren bij focus
      col.addEventListener('focusin', () => {
        clearTimeout(hoverTimer);
        activate(col);
      });
    });
  }
  
  // --- 3. Hover guard: voorkom dat het megamenu sluit terwijl de muis er nog in zit ---
  // Horizon opent het submenu met een clip-path animatie. Tijdens die animatie is het nog niet
  // onthulde deel voor de muis "onzichtbaar": beweeg je sneller naar beneden dan de animatie, dan
  // vuurt pointerleave op het menu-item en sluit Horizon het menu (flikkeren). Deze guard onderschept
  // dat pointerleave zolang de muis geometrisch binnen het open menu zit en sluit pas als de muis
  // het menugebied echt verlaat.
  function setupHoverGuard() {
    const headerMenu = document.querySelector('header-menu');
    if (!headerMenu || headerMenu.dataset.megaGuard === 'true') return;
    headerMenu.dataset.megaGuard = 'true';
    
    let activeItem = null;
    const MARGIN = 8;
    
    const getSubmenu = (item) => item && item.querySelector(':scope > .menu-list__submenu');
    
    const inMenuArea = (x, y) => {
      const submenu = getSubmenu(activeItem);
      if (!submenu) return false;
      const s = submenu.getBoundingClientRect();
      const i = activeItem.getBoundingClientRect();
      const headerEl = document.querySelector('header-component');
      const h = headerEl ? headerEl.getBoundingClientRect() : i;
      const top = Math.min(i.top, h.top) - MARGIN;
      const bottom = Math.max(s.bottom, h.bottom) + MARGIN;
      const left = Math.min(s.left, i.left) - MARGIN;
      const right = Math.max(s.right, i.right) + MARGIN;
      return x >= left && x <= right && y >= top && y <= bottom;
    };
    
    const release = (x, y) => {
      const item = activeItem;
      activeItem = null;
      if (item) {
        item.dispatchEvent(new PointerEvent('pointerleave', { bubbles: false, clientX: x, clientY: y }));
      }
    };
    
    // Capture op window: draait vóór de listeners van Horizon
    window.addEventListener('pointerenter', (e) => {
      if (e.pointerType === 'touch') return;
      const t = e.target;
      if (!(t instanceof Element)) return;
      const item = t.closest('.menu-list__list-item');
      if (item && getSubmenu(item)) activeItem = item;
    }, true);
    
    window.addEventListener('pointerleave', (e) => {
      if (e.pointerType === 'touch') return;
      const t = e.target;
      if (!(t instanceof Element) || !t.matches('.menu-list__list-item') || t !== activeItem) return;
      if (e.isTrusted && inMenuArea(e.clientX, e.clientY)) {
        // Muis zit nog in het menugebied: Horizon's deactivate tegenhouden
        e.stopImmediatePropagation();
      } else {
        activeItem = null;
      }
    }, true);
    
    document.addEventListener('pointermove', (e) => {
      if (!activeItem || e.pointerType === 'touch') return;
      if (!inMenuArea(e.clientX, e.clientY)) release(e.clientX, e.clientY);
    }, { passive: true });
    
    document.addEventListener('pointerdown', (e) => {
      if (!activeItem || e.pointerType === 'touch') return;
      if (!inMenuArea(e.clientX, e.clientY)) release(e.clientX, e.clientY);
    }, { passive: true });
  }
  
  function init() {
    document.querySelectorAll('.mega-menu__list').forEach(setupMegaMenu);
    setupHoverGuard();
  }
  
  // Eerste keer
  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
  
  // Horizon hertekent het menu — observeer en herstel banner + hover
  const observer = new MutationObserver(() => {
    init();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();